import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Container, Box, Typography, CircularProgress } from '@mui/material';
import { DEFAULT_THEME } from '../constants/themeDefaults';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { usePaymentIntent } from '../hooks/usePaymentIntent';
import PaymentForm from '../components/payment/PaymentForm';  // We'll create this component

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '');

interface PaymentDetailsProps {
  priceId?: string;
}

const PaymentDetails: React.FC<PaymentDetailsProps> = ({ priceId }) => {
  const theme = DEFAULT_THEME;
  const { clientSecret, error, loading, refreshIntent } = usePaymentIntent(priceId, true);

  useEffect(() => {
    console.log('💳 PaymentDetails mounted with priceId:', priceId);
    console.log('clientSecret:', clientSecret);
  }, [priceId, clientSecret]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography color="error">Error: {error}</Typography>
      </Box>
    );
  }

  if (!clientSecret) {
    return (
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography>Preparing payment form...</Typography>
      </Box>
    );
  }

  return (
    <Elements stripe={stripePromise} options={{ clientSecret }}>
      <PaymentForm priceId={priceId} />
    </Elements>
  );
};

export default PaymentDetails; 